<div style="display: inline-block">
  <h3>
    <b>{{ 'label.PromoEmailValidityDates' | translate }}</b>
  </h3>
  <div>
    <span>{{ 'label.From' | translate }} </span>
    <p-datepicker
      [(ngModel)]="templateData.validFrom"
      dateFormat="{{ specialDateFormat }}"
      [showIcon]="false"
    ></p-datepicker>
    <span> {{ 'label.To' | translate }} </span>
    <p-datepicker
      [(ngModel)]="templateData.validTo"
      dateFormat="{{ specialDateFormat }}"
      [showIcon]="false"
    ></p-datepicker>
  </div>
  <hr-field-state-marker [field]="fieldStates?.dates"></hr-field-state-marker
  ><br />
  <div>
    <span>{{ 'label.Name' | translate }}</span>
    <input type="text" [(ngModel)]="templateData.name" />
  </div>
  <br />
  <div>
    <span>{{ 'label.Subject' | translate }}</span>
    <input type="text" [(ngModel)]="templateData.subject" />
  </div>
  <br />
  <div>
    <span>{{ 'label.Attachment' | translate }} </span>
    <div
      *ngIf="templateData.attachments && templateData.attachments.length > 0"
      style="display: inline"
    >
      <span>(</span>
      <span
        *ngFor="let file of templateData.attachments"
        [ngClass]="{ 'deleted-attachment': file.isDeleted }"
      >
        {{ file.displayName }}
        <span
          *ngIf="!file.isDeleted"
          (click)="onAttachmentDelete(file)"
          class="delete-attachment"
          ><i class="fa fa-times-circle"></i
        ></span>
        <span
          *ngIf="file.isDeleted"
          (click)="onAttachmentRestore(file)"
          class="restore-attachment"
          ><i class="fa fa-undo"></i
        ></span>
        &nbsp;
      </span>
      <span>)</span>
    </div>
    <input
      type="file"
      ngFileSelect
      [options]="uploadOptions"
      [uploadInput]="uploadInput"
      (uploadOutput)="onUploadOutput($event)"
    />
  </div>
  <br />
  <div>
    <div>{{ 'label.Portfolio' | translate }}</div>
    <div class="multi-select-dropdown">
      <ul>
        <li *ngFor="let p of selectedPortfolios">
          {{ p?.name
          }}<button class="remove" (click)="onPortfolioDelete(p)">x</button>
        </li>
      </ul>
      <div>
        <select
          name="categories"
          [(ngModel)]="lastSelectedPortfolioId"
          (ngModelChange)="onPortfolioChange()"
        >
          <option value=""></option>
          <option
            *ngFor="let option of portfolios"
            value="{{ option.portfolioId }}"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <br />
  <div>
    <span>{{ 'label.EmailTemplate' | translate }}</span>
    <div style="max-width: 800px">
      <ckeditor [(ngModel)]="templateData.content"></ckeditor>
    </div>
  </div>
  <br />
  <p-button
    type="button"
    class="ui-button-secondary"
    (click)="onSave()"
    label="{{ 'label.Save' | translate }}"
  ></p-button>
  <p-button
    type="button"
    class="ui-button-secondary"
    (click)="onCancel()"
    label="{{ 'label.Cancel' | translate }}"
    style="margin-left: 1em"
  ></p-button>
  <hr-field-state-marker
    [field]="fieldStates?.common"
    style="float: right"
  ></hr-field-state-marker>
</div>
